<template>
  <b-modal
      :visible="visible"
      id="admin-new-shipper-modal"
      ref="modal"
      title="Add new Shipper"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Shipper Name">
        <b-form-input
            v-model.trim="formData.name"
            type="text"
            :state="fieldValid('name')"
        />
        <b-form-invalid-feedback :state="fieldValid('name')">
          {{ formValidation.name }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="License Number">
        <b-form-input
            v-model.trim="formData.license_number"
            type="text"
        />
        <b-form-invalid-feedback :state="fieldValid('license_number')">
          {{ formValidation.license_number }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Email Address">
        <b-form-input
            v-model.trim="formData.email"
            type="text"
        />
        <b-form-invalid-feedback :state="fieldValid('email')">
          {{ formValidation.email }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Phone Number">
        <b-form-input
            v-model.trim="formData.phone"
            type="text"
            placeholder="(###) ###-####"
            v-mask="'(###) ###-####'"
        />
        <b-form-invalid-feedback :state="fieldValid('phone')">
          {{ formValidation.phone }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="formState.processing">
        Save new Shipper
        <b-spinner v-if="formState.processing" class="ml-1" small/>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminNewShipperModal",
  emits: ['created'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        license_number: "",
        name: "",
        email: "",
        phone: ""
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-new-shipper-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-new-shipper-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.ADMIN_SHIPPERS, this.formData).then(({data}) => {
        this.$bvToast.toast('Shipper has been successfully created', {
          title: 'Success!',
          variant: 'success'
        });
        this.formValidation = {};
        this.$emit('created', data.shipper);
        this.formData = {
          license_number: "",
          name: "",
          email: ""
        };
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new shipper', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
